<template>
  <div>
    <h2>
      <span class="step-name">Hogget / Rams</span>
    </h2>
    <div class="step-section">
      <h3>Hogget Mating</h3>
      <radio-input
        label="Are hoggets mated? Please comment on target/focus and other discussion points"
        field-name="sheep_are_hoggets_mated"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
          { value: 'Sometimes', display: 'Sometimes' },
        ]"
      >
      </radio-input>

      <date-input
        field-name="sheep_hoggets_mating_date"
        @on-change="updateHoggetStartOfLambing"
        label="Hogget Mating Date"
      >
      </date-input>

      <date-input field-name="hogget_lambing_start_date" label="Calculated start of hogget lambing" disabled>
      </date-input>
    </div>

    <div class="step-section">
      <h3>Scanning: Hoggets</h3>
      <radio-input
        field-name="hogget_scan_for"
        label="Do you scan for:"
        :choices="[
          { display: 'Preg/Empty', value: 'preg/empty' },
          { display: 'Multiples', value: 'multiples' },
          { display: 'Triplets', value: 'triplets' },
          { display: 'None', value: 'none' },
        ]"
      >
      </radio-input>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group input-box">
            <label>Scanning % (Previous season) </label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').sheep_hog_scanning_percent"
              disabled
            />
          </div>

          <div class="form-group input-box">
            <label>Lambing % (Previous season) </label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').sheep_hog_tailing_percent"
              disabled
            />
          </div>
        </div>

        <div class="col-md-6">
          <number-input field-name="sheep_hog_scanning_percent" label="Scanning % (This season)"> </number-input>

          <number-input field-name="sheep_hog_tailing_percent" label="Lambing % (This season)"> </number-input>
        </div>
      </div>
    </div>

    <div class="step-section">
      <radio-input
        label="Are teasers used for the hoggets?"
        field-name="sheep_is_teasers"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <discussion-points
        title="Hogget Discussion Points"
        comments-field="hogget_discussion_points"
        points="Vaccinations, mating weight, mating selection, teasers, teaser timing."
      >
      </discussion-points>
    </div>

    <div class="step-section">
      <h3>Scanning History: Hoggets</h3>

      <h4>Hoggets Scanning %</h4>
      <line-chart
        :chart-data="getHoggetsData('av_scan', 'Region Average Scanning Percent', 'scan', 'Client Percent')"
      />

      <h4>Hoggets Lambing %</h4>
      <line-chart
        :chart-data="getHoggetsData('av_tail', 'Region Average Lambing Percent', 'tail', 'Client Lambing Percent')"
      />
    </div>

    <div class="step-section">
      <h3>Parasite Management</h3>

      <h3>All Drench Product Purchases</h3>

      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('sheep_drench_purchases', 'SheepReproductionPlan')" :key="index">
            <td class="text-left">{{ row['Purchase Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Stock Code - Name'] }}</td>
            <td class="text-left">{{ row['Quantity'] }}</td>
          </tr>
        </tbody>
      </table>

      <text-input
        label="Other drench products/actives used"
        field-name="sheep_other_drench_products_actives_used_not_vs"
        model-name="SheepReproductionPlan"
      >
      </text-input>

      <discussion-points
        title="Hogget Drench Discussion"
        comments-field="hogget_drench_discussion"
        points="Hogget drenching policy, pretup/prelamb, alternative management techniques"
      >
      </discussion-points>
    </div>

    <div class="step-section">
      <h2 class="step-name">Rams</h2>

      <radio-input
        label="Teasers"
        field-name="rams_is_teasers"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <radio-input
        label="Need Some Made"
        field-name="sheep_wants_teasers_made"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <radio-input
        label="Rams Examined"
        field-name="sheep_are_rams_examined"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

			<programme-input programme-slug="ram-run"></programme-input>

      <radio-input
        label="Interested in ram sedation?"
        field-name="sheep_wants_ram_sedation"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <discussion-points
        title="Ram Discussion Points"
        comments-field="ram_discussion_points"
        points="Palpations, Clostridial, Trace Elements, Pizzle Rot, Condition, Feet, Ram ratio, Shearing, Quarantine drench"
      >
      </discussion-points>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import LineChart from '@/components/charts/Line'

export default {
  name: 'HoggetMating',
  mixins: [baseComponent],
  components: {
    LineChart,
  },
  methods: {
    updateHoggetStartOfLambing: function ({ value }) {
      this.setFieldValue({
        modelName: this.$options.name,
        fieldName: 'hogget_lambing_start_date',
        value: this.$moment(value).add(147, 'days').format('YYYY-MM-DD'),
      })
    },

    getHoggetsData: function (field1, label1, field2, label2) {
      let data = Object.assign([], this.getFieldValue('CHARTS')['sheep_hog_scanning']).sort((a, b) =>
        a['year'] < b['year'] ? -1 : 0
      )

      return {
        labels: data.map((row) => row['year']),
        datasets: [
          {
            label: label1,
            pointBackgroundColor: '#3e95cd',
            backgroundColor: '#3e95cd',
            data: data.map((row) => parseFloat(row[field1] || '')),
            fill: false,
          },
          {
            label: label2,
            pointBackgroundColor: 'red',
            backgroundColor: 'red',
            data: data.map((row) => parseFloat(row[field2] || '')),
            fill: false,
          },
        ],
      }
    },
  },
}
</script>
